import { t } from '@lingui/core/macro';
import { isPresent } from '@luminovo/commons';
import { colorSystem, SearchInput } from '@luminovo/design-system';

import { Column, RowData } from '../tanstackTypes';
import { getFilterConfig, SupportedFilterFn } from '../type';
import { createFilterValueUpdater, isFilterValue } from './createFilterValueUpdater';

export function FilterIncludesString<TData extends RowData>({
    column,
    onClose,
}: {
    column: Column<TData, unknown>;
    onClose: () => void;
}): JSX.Element | null {
    const filterConfig = getFilterConfig(column, 'text');

    if (!isPresent(filterConfig)) {
        return null;
    }

    const filterValue = column.getFilterValue();
    const filterFn = isFilterValue(filterValue) ? filterValue.filterFn : filterConfig.defaultFilterFn;
    const value =
        isFilterValue<string>(filterValue) && typeof filterValue.value === 'string' ? filterValue.value : undefined;

    if (filterFn === SupportedFilterFn.isEmptyString || filterFn === SupportedFilterFn.isNotEmptyString) {
        return null;
    }

    return (
        <SearchInput
            placeholder={t`Type to filter`}
            value={value}
            debounceWait={50}
            onChange={(value) =>
                column.setFilterValue(
                    createFilterValueUpdater(Boolean(value) ? value : undefined, filterConfig.defaultFilterFn),
                )
            }
            onKeyEnter={onClose}
            onClear={() => column.setFilterValue(createFilterValueUpdater(undefined, filterConfig.defaultFilterFn))}
            style={{ backgroundColor: colorSystem.neutral.white }}
        />
    );
}
